import useAppStore from "../../stores/useAppStore";
import { T } from "../../styles/GlobalStyles";
import { useDeviceContext } from "../../hooks/useDeviceContext";

const ICONS = {
  success: "✓",
  error: "✕",
  info: "ℹ",
};

const COLORS = {
  success: T.accent,
  error: T.danger,
  info: T.muted,
};

/**
 * Toast global — un seul à la fois, piloté par `showToast` du uiSlice.
 * Auto-dismiss géré dans le store (3s).
 *
 * Position responsive :
 * - Mobile (isTerrain) : bottom-center, dans la thumb zone pour usage en journée
 * - Desktop (isBureau) : top-right, convention SaaS pour usage admin posé
 */
export default function Toast() {
  const message = useAppStore((s) => s.toastMessage);
  const type = useAppStore((s) => s.toastType);
  const { isBureau } = useDeviceContext();

  if (!message) return null;

  const color = COLORS[type] || COLORS.info;

  const positionStyle = isBureau
    ? { top: 24, right: 24 }
    : { bottom: 24, left: "50%", transform: "translateX(-50%)" };

  return (
    <div
      role="status"
      aria-live="polite"
      className="fade-in"
      style={{
        position: "fixed",
        ...positionStyle,
        background: T.surface,
        border: `1px solid ${color}50`,
        borderRadius: 12,
        padding: "10px 22px",
        fontSize: 13,
        fontWeight: 600,
        color,
        boxShadow: "0 8px 24px rgba(0,0,0,.4)",
        zIndex: 800,
        display: "flex",
        alignItems: "center",
        gap: 8,
        maxWidth: "90vw",
      }}
    >
      <span style={{ fontSize: 16 }}>{ICONS[type]}</span>
      {message}
    </div>
  );
}
